(function ($) {
  "use strict";
  jQuery(document).ready(function(){
  var windows = $(window);
  var sticky = $('.header-sticky');
  windows.on('scroll', function() {
    var scroll = windows.scrollTop();
    if (scroll < 100) {
      sticky.removeClass('is-sticky');
    }else{
      sticky.addClass('is-sticky');
    }
  }); 
  $("button.navbar-toggler").on("click", function(){
    $(".menu-mobile .main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });
  $(".close-box").on("click", function(){
    $(".menu-mobile .main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });
  $(".mm-fullscreen-bg").on("click", function(){
    $(".menu-mobile .main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });
  $(".mm-fullscreen-bg").on("click", function(){
    $(".mm-fullscreen-bg").removeClass("active");
  $(".filter-sidebar").removeClass("active");
  });
  $("button.filter-button").on('click', function() {
    $(".filter-sidebar").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
  });
  $("button.close-filter-sidebar").on('click', function() {
    $(".filter-sidebar").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
  });
  $('.grid').imagesLoaded(function () {
    $('.grid').isotope({
        itemSelector: 'li',
        layoutMode: 'masonry'
    });
  });
  $(window).scroll(function(){
    if ($(this).scrollTop() > 1000) {
      $('#top').fadeIn();
    } else {
      $('#top').fadeOut();
    }
  });
  $('#top').click(function(){
    $("html, body").animate({ scrollTop: 0 }, 100);
    return false;
  });
  $(document).on("click", ".st-hotspot .st-btn", function(e) {
      $(".st-hotspot").removeClass("open");
      $(".st-hotspot").removeClass("open");
      var hotspot = $(this).closest(".st-hotspot"),
      main_menu = hotspot.find(".st-content-parent").eq(0),
      tthotspotcontent = main_menu.find(".tt-hotspot-content").eq(0);
      if(hotspot.hasClass("open")){
        setTimeout(function() {
          hotspot.removeClass("open");
        }, 300);
        tthotspotcontent.removeClass("open");
      }else{
        hotspot.addClass("open");
        setTimeout(function() {
          tthotspotcontent.addClass("open");
        }, 300);
      }
    e.stopPropagation(); 
    e.preventDefault();
  });
  var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  })
});
})(jQuery);